// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rlgY","top":"styles_top__3_XS6"};